import { AddAccessApiRequest, AccessRequest } from '@model';
import { Action } from '@ngrx/store';
import { AccessRequestState } from 'app/models/enums/access-request-state.enum';

export enum CustomerAccessRequestsActionTypes {
    AccessRequestRequiredLoad = '[CustomerAccessRequest] Load Access Request Required',
    AccessRequestRequiredLoadSuccess = '[CustomerAccessRequest] Load Access Request Required Success',
    AccessRequestRequiredLoadFail = '[CustomerAccessRequest] Load Access Request Required Fail',
    AddAccessRequest = '[CustomerAccessRequest] Add Access Request',
    AddAccessRequestSuccess = '[CustomerAccessRequest] Add Access Request Success',
    AddAccessRequestFail = '[CustomerAccessRequest] Add Access Request Fail',
    CustomerAccessRequestsLoad = '[CustomerAccessRequest] Load Customer Access Requests',
    CustomerAccessRequestsLoadSuccess = '[CustomerAccessRequest] Load Customer Access Requests Success',
    CustomerAccessRequestsLoadFail = '[CustomerAccessRequest] Load Customer Access Requests Fail',
    ChangeAccessRequestState = '[CustomerAccessRequest] Change Access Request State',
    ChangeAccessRequestStateSuccess = '[CustomerAccessRequest] Change Access Request State Success',
    ChangeAccessRequestStateFail = '[CustomerAccessRequest] Change Access Request State Fail',
}

export class AccessRequestRequiredLoad implements Action {
    readonly type = CustomerAccessRequestsActionTypes.AccessRequestRequiredLoad;
    constructor(public payload: string) {}
}

export class AccessRequestRequiredLoadSuccess implements Action {
    readonly type = CustomerAccessRequestsActionTypes.AccessRequestRequiredLoadSuccess;
    constructor(public payload: boolean) {}
}

export class AccessRequestRequiredLoadFail implements Action {
    readonly type = CustomerAccessRequestsActionTypes.AccessRequestRequiredLoadFail;
    constructor(public payload: any) {}
}

export class AddAccessRequest implements Action {
    readonly type = CustomerAccessRequestsActionTypes.AddAccessRequest;
    constructor(public payload: AddAccessApiRequest) {}
}

export class AddAccessRequestSuccess implements Action {
    readonly type = CustomerAccessRequestsActionTypes.AddAccessRequestSuccess;
    constructor(public payload: boolean) {}
}
export class AddAccessRequestFail implements Action {
    readonly type = CustomerAccessRequestsActionTypes.AddAccessRequestFail;
    constructor(public payload: any) {}
}

export class CustomerAccessRequestsLoad implements Action {
    readonly type = CustomerAccessRequestsActionTypes.CustomerAccessRequestsLoad;
    constructor() {}
}
export class CustomerAccessRequestsLoadSuccess implements Action {
    readonly type = CustomerAccessRequestsActionTypes.CustomerAccessRequestsLoadSuccess;
    constructor(public payload: AccessRequest[]) {}
}

export class CustomerAccessRequestsLoadFail implements Action {
    readonly type = CustomerAccessRequestsActionTypes.CustomerAccessRequestsLoadFail
    constructor(public payload: any) {}
}

export class ChangeAccessRequestState implements Action {
    readonly type = CustomerAccessRequestsActionTypes.ChangeAccessRequestState
    constructor(public payload: { accessRequestId: number, newState: AccessRequestState }) {}
}

export class ChangeAccessRequestStateSuccess implements Action {
    readonly type = CustomerAccessRequestsActionTypes.ChangeAccessRequestStateSuccess;
    constructor(public payload: AccessRequest) {}
}

export class ChangeAccessRequestStateFail implements Action {
    readonly type = CustomerAccessRequestsActionTypes.ChangeAccessRequestStateFail
    constructor(public payload: any) {}
}

export type CustomerAccessRequestsActions =
    | AccessRequestRequiredLoad
    | AccessRequestRequiredLoadSuccess
    | AccessRequestRequiredLoadFail
    | AddAccessRequest
    | AddAccessRequestSuccess
    | AddAccessRequestFail
    | CustomerAccessRequestsLoad
    | CustomerAccessRequestsLoadSuccess
    | CustomerAccessRequestsLoadFail
    | ChangeAccessRequestState
    | ChangeAccessRequestStateSuccess
    | ChangeAccessRequestStateFail;
